import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import MenuButton from "./MenuButton";
import logo from "../../../images/logo-final-compressed/logo off white transparent 2.png";
import "../../css/Navbar.css";
import { FaCartShopping } from "react-icons/fa6";
import { getBasketQuantity } from "../code/basket";

const Navbar = ({ showLogo = true, isMenuOpen, setIsMenuOpen }) => {
  const [cartCount, setCartCount] = useState(getBasketQuantity());

  useEffect(() => {
    const updateCount = () => setCartCount(getBasketQuantity());
    window.addEventListener("basketUpdated", updateCount);
    updateCount();
    return () => window.removeEventListener("basketUpdated", updateCount);
  }, []);

  return (
    <div className="navbar">
      <div className="navbar-left">
        <MenuButton
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
        />
      </div>
      <div className="navbar-center">
        <AnimatePresence mode="wait">
          {showLogo && (
            <motion.div
              key="logo"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Link to="/">
                <img src={logo} alt="Logo" className="navbar-logo" />
              </Link>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <div className="navbar-right">
        <Link to="/checkout" className="navbar-button navbar-button-right">
          <FaCartShopping size={28} />
          {cartCount > 0 && <span className="checkout-badge">{cartCount}</span>}
        </Link>
      </div>
    </div>
  );
};

export default Navbar;